import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { Flex, FlexSpan, GrayButton, Icon, Table, TextInput } from "../../../ui";
import { InfoIcon } from "../../InfoIcon";
import { TableRowMenu } from "../../TableRowMenu";
import { TableHeaderContainer, TableStickyBodyCell } from "../../ParamsTable/styled";
const MAX_TABLE_ROWS_COUNT = 6;
export const Strategy = ({ values, onUpdateValues }) => {
    const [rowHover, setRowHover] = useState();
    const onAddRow = useCallback(() => {
        if (values.strategy_list.length === MAX_TABLE_ROWS_COUNT) {
            return;
        }
        onUpdateValues?.({
            strategy_list: [
                ...values.strategy_list,
                "",
            ],
        });
    }, [onUpdateValues, values.strategy_list]);
    const onPickMenuItem = useCallback((option, rowId) => {
        setRowHover(undefined);
        if (option.value === 1) {
            onUpdateValues?.({
                strategy_list: values.strategy_list.reduce((acc, curr, currIndex) => {
                    if (currIndex === rowId) {
                        return acc;
                    }
                    return [...acc, curr];
                }, []),
            });
        }
    }, [onUpdateValues, values.strategy_list]);
    return (_jsxs(Flex, { column: true, children: [_jsx(FlexSpan, { children: _jsx(Table, { cellGap: 0, columns: [
                        {
                            id: "value",
                            title: "Основные тезисы продуктовой стратегии",
                            width: "100%",
                            renderHead: column => (_jsx(TableHeaderContainer, { width: "100%", mb: "0.125rem", children: _jsxs(Flex, { alignItems: "center", children: [_jsx(FlexSpan, { fontSize: "16px", fontWeight: 600, children: column.title }), _jsx(FlexSpan, { display: "flex", children: _jsx(InfoIcon, { content: "Опишите планируемое предложение товаров / услуг: укажите количество товарных групп («ширина» ассортимента), " +
                                                    "среднее количество брендов в группе («глубина» ассортимента), а также общее количество уникальных товаров / услуг" }) })] }) })),
                            renderBody: (_, rowId) => {
                                return (_jsxs(TableStickyBodyCell, { firstRow: rowId === 0, lastRow: rowId === values.strategy_list.length - 1, firstCol: true, lastCol: true, isEditing: true, width: "calc(100% - 0.375rem)", onMouseOver: () => rowHover === undefined && setRowHover(rowId), onMouseLeave: () => setRowHover(undefined), children: [rowHover === rowId && (_jsx(TableRowMenu, { items: [
                                                {
                                                    value: 1,
                                                    label: "Удалить строку",
                                                    prefix: _jsx(Icon, { icon: "trash" }),
                                                },
                                            ], onPick: option => onPickMenuItem(option, rowId) })), _jsx(TextInput, { style: { border: "none" }, inputStyle: { fontSize: "0.75rem", padding: "0 0.75rem" }, height: "2.5rem", maxLength: 160, value: values.strategy_list[rowId] ?? "", onChange: value => onUpdateValues?.({
                                                strategy_list: Array.from({ length: values.strategy_list.length }, (__, itemIndex) => {
                                                    return itemIndex === rowId ? value : (values.strategy_list?.[itemIndex] || "");
                                                }),
                                            }) })] }));
                            },
                        },
                    ], rows: values.strategy_list.map(() => ({ data: {} })) }) }), _jsx(FlexSpan, { width: "100%", mt: "1rem", children: _jsx(GrayButton, { icon: "plus", buttonSize: "s", width: "100%", disabled: values.strategy_list.length >= MAX_TABLE_ROWS_COUNT, onClick: onAddRow, children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u0443" }) })] }));
};
